import React, { Suspense, lazy, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ScanRedirect from "../components/ScanRedirect";
import { resolveTableToken } from "../utils/browserOrderingData";
import { engineGatewayUrl } from "./engineConfig";
import { chooseDinePage } from "./dineChoice";
import { Muted, Page, Panel } from "./ui";

// Loaded only for engine restaurants, so the V1 page (and Stripe's script) stay as they were.
const EngineDine = lazy(() => import("./EngineDine"));

// /dine/<token>: the table's QR, scanned with the phone camera. A restaurant
// switched onto the V2 engine (features.newEngine) gets the engine's guest
// page; every other restaurant, and every build without a V2 gateway
// (production and QA), gets the V1 page exactly as before.
const DineRouter = () => {
	const { token } = useParams();
	const [choice, setChoice] = useState(() => (engineGatewayUrl() ? null : { page: "v1" }));

	useEffect(() => {
		if (!engineGatewayUrl()) return undefined;
		let live = true;
		setChoice(null);
		chooseDinePage(token, { gatewayUrl: engineGatewayUrl(), resolve: resolveTableToken }).then((next) => live && setChoice(next));
		return () => {
			live = false;
		};
	}, [token]);

	const finding = (
		<Page>
			<Panel>
				<Muted aria-live="polite">Finding your table...</Muted>
			</Panel>
		</Page>
	);
	if (!choice) return finding;
	if (choice.page === "engine") {
		return (
			<Suspense fallback={finding}>
				<EngineDine key={token} gatewayUrl={choice.gatewayUrl} restaurant={choice.restaurant} table={choice.table} />
			</Suspense>
		);
	}
	return <ScanRedirect />;
};

export default DineRouter;
